import React from 'react';
import { AnyObject } from 'final-form';
import { IRootState } from 'src/reducers';
import { connect } from 'react-redux';
import PropertyUtil from 'src/util/PropertyUtil';
import LeaseDocMenu from './LeaseDocMenu';
import LeaseClause from 'src/models/LeaseClause';
import moment from 'moment';
import actions from 'src/actions';
import PDFWindow from 'src/components/common/PDFWindow';
import DemoLease from './LeaseDocuments/DemoLease';
import MathUtil from 'src/util/MathUtil';
import Acknowledgement from 'src/models/leasing/Acknowledgement';

interface ILeaseDocumentStateProps {
    leaseData: AnyObject;
    leaseClauses?: LeaseClause[];
}

export interface ILeaseDocumentDispatchProps {
    showDialog: (dialogName: string) => void;
}

type LeaseDocumentState = {
    dataFieldClass: string;
};

type ILeaseDocumentPageProps = ILeaseDocumentStateProps & ILeaseDocumentDispatchProps;

class LeaseDocument extends React.Component<ILeaseDocumentPageProps, LeaseDocumentState> {
    constructor(props: ILeaseDocumentPageProps) {
        super(props);

        this.state = {
            dataFieldClass: undefined,
        };
    }

    placeHolderField = (fieldName: string) => {
        return <span className="place-holder">&lt;&lt;{fieldName}&gt;&gt;</span>;
    };

    printPage = () => {
        window.print();
    };

    additionalProvisions = () => {
        console.log('this shoudl be working!!!');

        const addendumClauses: Array<LeaseClause> = !!this.props?.leaseData?.leaseData?.leaseClauses
            ? this.props?.leaseData?.leaseData?.leaseClauses?.map((llc: AnyObject) => {
                  let clause: LeaseClause = !!this.props?.leaseData?.leaseClauses
                      ? this.props?.leaseData?.leaseClauses?.find((lc: AnyObject) => lc.id === llc.clientApprovedLeaseClauseId)
                      : undefined;
                  return clause;
              })
            : [];

        console.log('addendumClauses, ', addendumClauses);
        console.log('lease Clauses, ', this.props.leaseData?.leaseClauses);

        const leaseClauses: Array<LeaseClause> = this.props?.leaseData?.leaseData
            ? this.props?.leaseData?.leaseData?.adHocClauses.concat(addendumClauses)
            : [];

        return leaseClauses?.map((lc: LeaseClause, index: number) => {
            return (
                <div key={index}>
                    <p>
                        <span className="text-bold mr-1">{index + 1}</span>
                        {lc?.clauseText}
                    </p>
                </div>
            );
        });
    };

    highlightDataFields = () => {
        if (this.state.dataFieldClass === undefined) {
            this.setState({ dataFieldClass: 'highlight-fields' });
        } else {
            this.setState({ dataFieldClass: undefined });
        }
    };

    displaySignatureBlocks = () => {
        // ?? Is this the actual prop body?
        return this.props?.leaseData?.leaseData
            ? this.props?.leaseData?.leaseData?.acknowledgements?.map((la: Acknowledgement) => {
                  return (
                      la.signatureBlocks.length > 0 &&
                      la.signatureBlocks.map((sb) => {
                          return (
                              <>
                                  <div>
                                      <div>IN TESTIMONY WHEREOF, I sign the ____ day of ____________________, 20____.</div>
                                      <div>{!!sb.title ? `${sb.title}:` : 'Lessor: '}</div>
                                      <div>______________________________________________</div>
                                      <div>{sb.ownerName}</div>
                                  </div>
                              </>
                          );
                      })
                  );
              })
            : [];
    };

    displayAcknowledgements = () => {
        return this.props?.leaseData?.leaseData
            ? this.props?.leaseData?.leaseData?.acknowledgements?.map((la: Acknowledgement) => {
                  let text: string = la.text;
                  let numberOfLines = text.match(/\n/g);
                  let rows = numberOfLines.length + 4;
                  return (
                      <>
                          <div className="double-line" />
                          <textarea
                              defaultValue={la.text}
                              disabled={true}
                              style={{
                                  border: 'none',
                                  backgroundColor: 'white',
                                  resize: 'none',
                                  fontFamily: 'auto',
                                  fontSize: 'initial',
                                  width: '100%',
                              }}
                              rows={rows}
                          />
                          <div className="double-line" />
                      </>
                  );
              })
            : [];
    };

    /* tslint:disable:max-line-length */
    public render() {
        const leaseValues = PropertyUtil.SafeGet(() => this.props.leaseData.leaseData);
        const leaseClauses = PropertyUtil.SafeGet(() => this.props.leaseData?.leaseClauses);
        const firstIncludedTract = leaseValues?.tracts?.find((tract: AnyObject) => tract.includeTract === true);
        const totalGrossAcres = leaseValues?.tracts?.reduce((acc: number, tract: AnyObject) => {
            if (tract.includeTract === true) {
                let tempGrossAcres = parseFloat(tract.grossAcres) || 0;
                return acc + tempGrossAcres;
            } else {
                return acc;
            }
        }, 0);

        console.log('current leaseValues', leaseValues, 'firstIncludedTract', firstIncludedTract);

        return (
            <div className="lease-page">
                <div className="lease-document">
                    <div className="mailing-info">
                        <div>After recording return to:</div>
                        <div>
                            <span className={this.state.dataFieldClass}>
                                {PropertyUtil.SafeGet(() => leaseValues.lesseeName, this.placeHolderField('LESSEE NAME'))}
                            </span>
                        </div>

                        <div>
                            <span className={this.state.dataFieldClass}>
                                {PropertyUtil.SafeGet(() => leaseValues.lesseeAddressLine1, this.placeHolderField('ADDRESS'))}
                            </span>
                        </div>
                        <div>
                            <span className={this.state.dataFieldClass}>{PropertyUtil.SafeGet(() => leaseValues.lesseeAddressLine2, '')}</span>
                        </div>
                        <div>
                            <span className={this.state.dataFieldClass}>
                                {PropertyUtil.SafeGet(
                                    () => leaseValues.lesseeCity + ', ' + leaseValues.lesseeState + ' ' + leaseValues.lesseeZipCode,
                                    this.placeHolderField('CITY, STATE, ZIP')
                                )}
                            </span>
                        </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <h1>OIL AND GAS LEASE</h1>
                        <h3 className="paid-up">(PAID UP)</h3>
                    </div>

                    <div className="mb-4">
                        AGREEMENT, Made and entered into this{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => moment(leaseValues.effectiveDate).format('Do'), this.placeHolderField('DAY'))}
                        </span>{' '}
                        day of{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => moment(leaseValues.effectiveDate).format('MMMM'), this.placeHolderField('MONTH'))}
                        </span>
                        ,{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => moment(leaseValues.effectiveDate).format('YYYY'), this.placeHolderField('YEAR'))}
                        </span>
                        , by and between{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => leaseValues.ownersOnDocument, this.placeHolderField('LESSOR NAME'))}
                        </span>
                        , whose address is{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => leaseValues.ownersAddressOnDocument, this.placeHolderField('LESSOR ADDRESS'))}
                        </span>
                        , Party of the first part, hereinafter called "Lessor" (whether one or more), and{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => leaseValues.lesseeName, this.placeHolderField('LESSEE NAME'))}
                        </span>
                        , whose address is{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(
                                () =>
                                    leaseValues.lesseeAddressLine1 +
                                    ', ' +
                                    leaseValues.lesseeCity +
                                    ', ' +
                                    leaseValues.lesseeState +
                                    ', ' +
                                    leaseValues.lesseeZipCode,
                                this.placeHolderField('LESSEE ADDRESS')
                            )}
                        </span>
                        , Party of the second part, hereinafter called "Lessee".
                    </div>

                    <div className="mb-3">
                        WITNESSETH, That said Lessor, for and in consideration of Ten and More ($10.00) DOLLARS, cash in hand paid, receipt of which
                        is hereby acknowledged and of the covenants and agreements hereinafter contained on the part of Lessee to be paid, kept and
                        performed, has granted, demised, leased and let and by these presents does grant, demise, lease and let exclusively unto the
                        said Lessee, for the sole and only purpose of exploring by geophysical and other methods, mining and operating for oil
                        (including but not limited to distillate and condensate), gas (including casinghead gas and helium and all other
                        constituents), and for laying pipe lines, and building tanks, power stations and structures thereon, to produce, save and take
                        care of said products, all that certain tract of land, together with any reversionary rights therein, situated in the of{' '}
                        {/* <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => firstIncludedTract?.county?.name, this.placeHolderField('COUNTY'))}
                        </span> */}
                        State of Texas, described as follows, to-wit:
                    </div>

                    <div className="location mb-2">
                        Township{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => firstIncludedTract?.township, this.placeHolderField('TWP'))}
                        </span>
                        , Range{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => firstIncludedTract?.range, this.placeHolderField('RNG'))}
                        </span>
                        , Section{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => firstIncludedTract?.section, this.placeHolderField('SEC'))}
                        </span>
                        , I.M.
                    </div>

                    <div className="mb-2">
                        <span className={this.state.dataFieldClass} style={{ whiteSpace: 'break-spaces' }}>
                            {!leaseValues?.legalDescription
                                ? this.placeHolderField('LEGAL DESCRIPTION')
                                : leaseValues?.legalDescription?.length > 1000
                                ? this.placeHolderField('SEE EXHIBIT A ...')
                                : leaseValues?.legalDescription}
                            {/* {PropertyUtil.SafeGet(
                                () => leaseValues.leaseDescription.split('\n').map((desc: string, index: number) => <div key={index}>{desc}</div>),
                                this.placeHolderField('LEGAL DESCRIPTION')
                            )} */}
                        </span>
                    </div>

                    <div className="mb-3">
                        and containing (
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => totalGrossAcres, this.placeHolderField('ACRES'))}
                        </span>
                        ) acres more or less (the "Lands" or "Leased Premises").
                    </div>

                    <div className="mb-2">
                        It is agreed that this lease shall remain in force for a term of{' '}
                        {PropertyUtil.SafeGet(
                            () => MathUtil.numberToEnglish(parseInt(leaseValues?.leasehold?.primaryTerm, 10)),
                            this.placeHolderField('LEASE TERM WORD')
                        )}{' '}
                        (
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => leaseValues?.leasehold?.primaryTerm, this.placeHolderField('LEASE TERM'))}
                        </span>
                        )<span>{leaseValues?.leasehold?.primaryTermUnits}</span> from{' '}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => leaseValues.effectiveDate, this.placeHolderField('LEASE DATE'))}
                        </span>{' '}
                        ( herein called primary term) and so long thereafter as oil or gas, or either of them, is produced from said land by Lessee.
                    </div>

                    <div className="mb-2">In consideration of the premises Lessee covenants and agrees:</div>

                    <div className="mb-2">
                        1st. To deliver in-kind to Lessor, at the well, or to the credit of Lessor into the pipeline or storage tank to which the well
                        may be connected, a (
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => leaseValues?.leasehold?.royalty, this.placeHolderField('Royalty'))}
                        </span>
                        th) part of all oil (including condensate) produced and saved from the leased premises. In lieu thereof, Lessee shall have the
                        option, at any time, to sell Lessor's oil, in which case Lessor's royalty shall be based on Lessee's gross proceeds at the
                        mouth of the well, or to purchase Lessor's oil for the value of such oil at the mouth of the well. In any event, Lessor's
                        interest shall be free of all costs of production, but shall bear its proportionate part of production and similar taxes, and
                        shall share proportionately with Lessee in any costs to market, transport, or condition the oil.
                    </div>

                    <div className="mb-2">
                        2nd. To pay Lessor for gas (including casinghead gas and coal bed methane gas) of whatsoever nature or kind (with all of its
                        consituents) produced and sold or used off the Leased Premises, or used in the manufacture of products therefrom, (
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => leaseValues?.leasehold?.royalty, this.placeHolderField('Royalty'))}
                        </span>
                        th) of the gross proceeds received from any party (whether or not an affiliate of Lessee) for the gas sold, used off the
                        Leased Premises or in the manufacture of products therefrom, less a proportionate part of any production, severance and other
                        excises taxes and costs and/or fees incurred by Lessee in making marketable Lessor’s share of gas, and/or in gathering,
                        transporting, processing, compressing or otherwise marketing Lessor’s share of gas, but in no event more than (
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => leaseValues?.leasehold?.royalty, this.placeHolderField('Royalty'))}
                        </span>
                        th) of the net amount actually received by Lessee from any such party, said payments to be made monthly. During any period
                        (whether before or after expiration of the primary term hereof) when gas is not being so sold or used and the well or wells
                        are shut in and there is no current production of oil or operations on said Leased Premises sufficient to keep this lease in
                        force, Lessee shall pay or tender a royalty of One Dollar ($1.00) per year per net royalty acre retained here-under, such
                        payment or tender to be made, on or before the anniversary date of this lease next ensuing after the expiration of ninety (90)
                        days from the date such well is shut in and thereafter on the anniversary date of this lease during the period such well is
                        shut in, to the royalty owners. When such payment or tender is made it will be considered that gas is being produced within
                        the meaning of the entire lease.
                    </div>

                    <div className="mb-2">
                        If Lessee shall commence operations to drill a well or commence reworking operations on an existing well within the term of
                        this lease or any extension thereof, or on acreage pooled therewith, Lessee shall have the right to drill such well to
                        completion or complete reworking operations with reasonable diligence and dispatch, and if oil or gas, or either of them, be
                        found in paying quantities, this lease shall continue and be in force with like effect as if such well had been completed
                        within the term of years first mentioned.
                    </div>

                    <div className="page-number">1</div>
                </div>

                <div className="lease-document">
                    <div className="mb-2">
                        Lessee is hereby granted the right at any time and from time to time to unitize the Leased Premises or any portion or portions
                        thereof, as to all strata or any stratum or strata, with any other lands as to all strata or any stratum or strata, for the
                        production primarily of oil or primarily of gas with or without distillate. However, no unit for the production primarily of
                        oil shall embrace more than 40 acres, or for the production primarily of gas with or without distillate more than 640 acres;
                        provided that if any governmental regulation shall prescribe a spacing pattern for the development of the field or allocate a
                        producing allowable based on acreage per well, then any such unit may embrace as much additional acreage as may be so
                        prescribed or as may be used in such allocation of allowable.
                    </div>

                    <div className="mb-2">
                        Operations upon and production from the unit shall be treated as if such operations were upon or such production were from the
                        Leased Premises whether or not the well or wells are located thereon. The entire acreage within a unit shall be treated for
                        all purposes as if it were covered by and included in this lease except that the royalty on production from the unit shall be
                        as below provided, and except that in calculating the amount of any shut in gas royalties, only the part of the acreage
                        originally leased and then actually embraced by this lease shall be counted. In respect to production from the unit, Lessee
                        shall pay Lessor, in lieu of other royalties thereon, only such proportion of the royalties stipulated herein as the amount of
                        his acreage placed in the unit, or his royalty interest therein on an acreage basis bears to the total acreage in the unit.
                    </div>

                    <div className="mb-2">
                        If said Lessor owns a less interest in the above described land than the entire and undivided fee simple estate therein, then
                        the royalties herein provided shall be paid to the Lessor only in the proportion which his interest bears to the whole and
                        undivided fee.
                    </div>

                    <div className="mb-2">
                        Lessee shall have the right to use, free of cost, gas, oil and water produced on said land for its operations thereon, except
                        water from wells of Lessor.
                    </div>

                    <div className="mb-2">When requested by Lessor, Lessee shall bury its pipe lines below plow depth.</div>

                    <div className="mb-2">
                        No well shall be drilled nearer than 200 feet to the house or barn now on said premises, without the written consent of
                        Lessor. Lessee shall pay for all damages caused by its operations to growing crops on said land.
                    </div>

                    <div className="mb-2">
                        Lessee shall have the right at any time to remove all machinery and fixtures placed on said premises, including the right to
                        draw and remove casing.
                    </div>

                    <div className="mb-2">
                        If the estate of either Party hereto is assigned, and the privilege of assigning in whole or in part is expressly allowed, the
                        covenants hereof shall extend to their heirs, executors, administrators, successors or assigns. However, no change or division
                        in ownership of the land or royalties shall enlarge the obligations or diminish the rights of Lessee. No change in the
                        ownership of the land or royalties shall be binding on the Lessee until after the Lessee has been furnished with a written
                        transfer or assignment or a true copy thereof. In case Lessee assigns this lease, in whole or in part, Lessee shall be
                        relieved of all obligations with respect to the assigned portion or portions arising subsequent to the date of assignment.
                    </div>

                    <div className="mb-2">
                        All express or implied covenants of this lease shall be subject to all Federal and State Laws, Executive Orders, Rules and
                        Regulations, and this lease shall not be terminated, in whole or in part, nor Lessee held liable in damages, for failure to
                        comply therewith, if compliance is prevented by, or such failure is the result of any such Law, Order, Rule or Regulation.
                    </div>

                    <div className="mb-2">
                        This lease shall be effective as to each Lessor on execution hereof as to his or her interest and shall be binding on those
                        signing, notwithstanding some of the Lessors above named may not join in the execution hereof. The word “Lessor” as used in
                        this lease means the Party or Parties who execute this lease as Lessor, although not named above.
                    </div>

                    <div className="mb-2">
                        Lessee may at any time and from time to time surrender this lease as to any part or parts of the Leased Premises by delivering
                        or mailing a release thereof to Lessor, or by placing a release of record in the proper County.
                    </div>

                    <div className="mb-2">
                        Lessor specifically grants Lessee the right to conduct geophysical operations on the Lands covered by this lease and
                        acknowledges Lessee will own the seismic data resulting from said geophysical operations and is free to utilize the seismic
                        data for its sole and exclusive benefit. Lessor hereby grants and conveys to Lessee any and all rights in and to existing
                        wellbores located on the Lands described above, including the right to re-enter said wellbore(s) and utilize same for Lessees
                        benefit.
                    </div>

                    <div className="mb-2">
                        If at any time within the primary term of this lease and while the same remains in force and effect, Lessor receives any bona
                        fide offer, acceptable to Lessor, to grant an additional lease (top lease) covering all or part of the aforementioned Lands,
                        Lessee shall have the continuing option by meeting any such offer to acquire such top lease. Any offer must be in writing, and
                        must set forth the proposed lessee's name, bonus consideration and royalty consideration to be paid for such lease and include
                        a copy of the lease form to be utilized which form should reflect all pertinent and relevant terms and conditions of the top
                        lease. Lessee shall have fifteen (15) days after receipt, from Lessor, of a complete copy of any such offer to advise Lessor
                        in writing of its election to enter into an oil and gas lease with Lessor on equivalent terms and conditions. If Lessee fails
                        to notify Lessor with the aforesaid fifteen (15) day period of its election to meet any such bona fide offer, Lessor shall
                        have the right to accept said offer. Any top lease granted by Lessor in violation of this provision shall be null and void.
                    </div>

                    <div className="mb-3">
                        Lessor hereby warrants and agrees to defend the title to the Lands herein described, and agrees that Lessee shall have the
                        right at any time to redeem for Lessor by payment any mortgages, taxes or other liens on the above described Lands, in the
                        event of default of payment by Lessor, and be subrogated to the rights of the holder thereof.
                    </div>

                    <div className="mb-4">
                        It is the intent of the Lessor to lease, and Lessor does hereby grant, demise, lease and let unto Lessee, all oil, gas and
                        other minerals owned by Lessor in Section (
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => firstIncludedTract?.section, this.placeHolderField('SEC'))}
                        </span>
                        ), Township (
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => firstIncludedTract?.township, this.placeHolderField('TWP'))}
                        </span>
                        ), Range (
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => firstIncludedTract?.range, this.placeHolderField('RNG'))}
                        </span>
                        )
                        {/* <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => firstIncludedTract?.county?.name, this.placeHolderField('COUNTY'))}
                        </span>
                        ) County, */}
                        <span className={this.state.dataFieldClass}>
                            {PropertyUtil.SafeGet(() => leaseValues.location.state, this.placeHolderField('STATE'))}
                        </span>{' '}
                        whether or not properly and completely described herein. In the event it is determined that Lessor actually owns more net
                        mineral acres than that assumed by the parties in the calculation of lease bonus and paid by Lessee, Lessor and Lessee agree
                        that Lessee shall pay Lessor for such additional net acreage at the same bonus price per acre agreed upon for the execution of
                        this oil and gas lease. Likewise, in the event it is determined that Lessor owns less net acres, or it is determined that
                        Lessor's acreage is currently leased under a prior oil and gas lease, then the Lessor agrees to reimburse Lessee for the bonus
                        per acre paid for the acreage not owned by Lessor or under the prior oil and gas lease.
                    </div>

                    <div className="page-number">2</div>
                </div>

                {PropertyUtil.SafeGet(() => leaseValues.acknowledgements.length > 0) && (
                    <div className="lease-document">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', rowGap: '5rem' }}>
                            {this.displaySignatureBlocks()}
                        </div>
                        <div className="page-number mt-3">5</div>
                    </div>
                )}
                {PropertyUtil.SafeGet(() => leaseValues.acknowledgements.length > 0) && (
                    <div className="lease-document">
                        <h2 className="lh-align-center">(ACKNOWLEDGEMENT)</h2>
                        {this.displayAcknowledgements()}
                    </div>
                )}

                {PropertyUtil.SafeGet(() => leaseValues.legalDescription.length > 1000) && (
                    <div className="lease-document">
                        <h2 className="lh-align-center">Exhibit A</h2>
                        <span className={this.state.dataFieldClass} style={{ whiteSpace: 'break-spaces' }}>
                            {leaseValues?.legalDescription}
                        </span>
                        <div className="page-number mt-3">5</div>
                    </div>
                )}

                {PropertyUtil.SafeGet(() => leaseValues.adHocClauses.length > 0) && (
                    <div className="lease-document">
                        <h2 className="lh-align-center">Exhibit {leaseValues.legalDescription.length > 1000 ? 'B' : 'A'}</h2>
                        <h3 className="lh-align-center">Additional Provisions</h3>
                        {this.additionalProvisions()}
                        <div className="page-number mt-3">5</div>
                    </div>
                )}

                <LeaseDocMenu printPage={this.printPage} highlightDataFields={this.highlightDataFields} showDialog={this.props.showDialog} />

                <PDFWindow>
                    <DemoLease contractData={leaseValues} leaseClauses={leaseClauses} />
                </PDFWindow>
            </div>
        );
    }
}

function mapStateToProps(state: IRootState) {
    return {
        leaseData: state.navigation.formState,
        leaseClauses: state.navigation.formState,
    };
}

const mapDispatchToProps: ILeaseDocumentDispatchProps = {
    showDialog: (dialogName: string) => actions.layout.showDialog(dialogName),
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaseDocument);



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/LeaseDocument.tsx